import React from 'react';
import { ParagraphXSmallRegular } from 'components/Typography';
import { ScheduleClosureForm } from 'components/ScheduleClosureForm';
import { ScheduledClosuresTable } from 'components/ScheduledClosuresTable';
import { Setting, SettingDetail, SettingInfo, SettingsSection, SettingsSectionHeading, SettingsSectionSubHeading } from 'components/Setting/style';
import { ExternalLink } from 'components/ExternalLink';
import { STRINGS } from 'config';

const {
  USER_SUPPORT_RESOURCES: { SCHEDULED_CLOSURES_HELP_URL },
} = STRINGS;

export const ScheduledClosures = () => (
  <SettingsSection>
    <Setting>
      <SettingInfo>
        <SettingsSectionHeading as="h2">
          Closures
        </SettingsSectionHeading>

        <ParagraphXSmallRegular>
          Close your eConsult service today, or schedule a closure, for up to five working days.
          To find out more about closures, click&nbsp;
          <ExternalLink label="here." automationName="link-to-closures-info" url={SCHEDULED_CLOSURES_HELP_URL} />
        </ParagraphXSmallRegular>
      </SettingInfo>

      <SettingDetail>
        <ScheduleClosureForm />
      </SettingDetail>
    </Setting>

    <Setting>
      <SettingInfo>
        <SettingsSectionSubHeading as="h3">
          Active and future closures
        </SettingsSectionSubHeading>
      </SettingInfo>

      <SettingDetail>
        <ScheduledClosuresTable />
      </SettingDetail>
    </Setting>
  </SettingsSection>
);
